/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{isSome as r}from"../../core/arrayUtils.js";import{supportsCurves as o,execute as t}from"./gx/operatorAutoComplete.js";import{getSpatialReference as p,fromSpatialReference as e,fromPolyline as s,fromPolygon as m,toPolygon as a}from"./support/apiConverter.js";function i(o,i){const u=p(o);return t(o.map(m),i.map(s),e(u)).map((r=>a(r,u))).filter(r)}const u=o();export{i as execute,u as supportsCurves};
